<template>
    <div class="relative bg-wrap-color">
        <template v-if="isPageAllowed">
            <div class="bg-color" style="padding-bottom: 10px;transition: none;" v-show="!ads_show">
                <div class="tab-bar relative">
                    <el-tabs v-model="activeTabName" @tab-click="changeTab" @click.native="clickTabItem">
                        <el-tab-pane label="广告系列组" name="apple_org" v-if="pageActionNames.includes('apple_org')">
                            <OrgPage v-if="activeTabName == 'apple_org'" ref="apple_org" :mixin-loading="mixinLoading" :page-dimension="pageDimension" :page-fields="rawFields" :page-func="pageFunc" :zone="timeZone" :range-time="range_time" :page-action-names="pageActionNames"/>
                        </el-tab-pane>
                        <el-tab-pane label="广告系列" name="apple_campaign" v-if="pageActionNames.includes('apple_campaign')">
                            <CampaignPage v-if="activeTabName == 'apple_campaign'" ref="apple_campaign" :mixin-loading="mixinLoading" :page-dimension="pageDimension" :page-fields="rawFields" :page-func="pageFunc" :zone="timeZone" :range-time="range_time" :page-action-names="pageActionNames" @click-add="handleClickAddCampaign"/>
                        </el-tab-pane>
                        <el-tab-pane label="广告组" name="apple_adgroup" v-if="pageActionNames.includes('apple_adgroup')">
                            <AdGroup v-if="activeTabName == 'apple_adgroup'" ref="apple_adgroup" :mixin-loading="mixinLoading" :page-dimension="pageDimension" :page-fields="rawFields" :page-func="pageFunc" :zone="timeZone" :range-time="range_time" :page-action-names="pageActionNames" @click-add="handleClickAddGroup"/>
                        </el-tab-pane>
                        <el-tab-pane label="关键词" name="keywords" v-if="isHasKeywordTabs">
                            <Keywords v-if="activeTabName == 'keywords'" ref="keywords" :mixin-loading="mixinLoading" :page-dimension="pageDimension" :page-fields="rawFields" :page-func="pageFunc" :zone="timeZone" :range-time="range_time" :page-action="pageAction" :page-action-names="pageActionNames"/>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
            <TimeZone v-show="!ads_show" class="inline-block time-zone" :zone="timeZone" @change="updateZone" :range-time="range_time" :page-func-names="pageFuncNames" @click-add="AddAd" :add-loading="addLoading"/>

            <CreateAds v-if="ads_show" :pre-data="preData" ref="createAds" @adsClose="handleadsClose"></CreateAds>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>Apple广告投放平台</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {pageMixin} from '../../mixins/pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import OrgPage from './org/index';
    import CampaignPage from './campaign/index';
    import AdGroup from './adGroup/index';
    import Keywords from './keywords/index';
    import CreateAds from './create/index';


    import TimeZone from './components/timeZone';
    import API from '@/api/marketManage/apple/index';
    import dayjs from 'dayjs';
    import {handleDocumentNoctiyClick} from "./components/getFlagHtml.js";
    export default {
        name: "AppleIndex",
        mixins: [pageMixin],
        components:{
            NoPermissionInfo,
            OrgPage,
            CampaignPage,
            TimeZone,
            AdGroup,
            Keywords,
            CreateAds
        },
        data() {
            return {
                isPageAllowed: true,
                activeTabName:'',
                timeZone:'',
                range_time:[],
                routeTabNames:[],
                ads_show: false,  //创建广告
                addLoading:false,
                priceDecimalConfig:[],
                preData:{
                    org_id:'',
                    org_name:'',
                    campaign_id:'',
                    campaign_name:'',
                    adgroup_id:'',
                    adgroup_name:'',
                },
            }
        },
        provide(){
            return {
                priceDecimalConfig:this.getPriceDecimalConfig,
            }
        },
        computed:{
            ...mapGetters(['tabs_map', 'apple_create_type','apple_common_config','apple_list_page_query']),
            isHasKeywordTabs(){
                let hasKeyword = this.pageActionNames.includes('apple_keyword');
                let hasSearchTerm = this.pageActionNames.includes('apple_search_term');
                let hasNegativeKeyword = this.pageActionNames.includes('apple_negative_keyword');
                return hasKeyword||hasSearchTerm||hasNegativeKeyword;
            },
            pageActionNames(){
                let tabsMap =  this.tabs_map||{};
                let apple =tabsMap.apple||[];
                return apple.map(item=>item.name);
            },
            pageFuncNames(){
                return (this.pageFunc||[]).map(item=>item.name);
            },
        },
        watch: {
            apple_create_type: {
                handler(val, oldVal) {
                    if(val == 'createOrg' || val == 'editOrg') {
                        this.activeTabName = 'apple_campaign'
                    }else if(val == 'createGroup' || val == 'editGroup') {
                        this.activeTabName = 'apple_adgroup'
                    }
                },
                deep: true, // 深度监听
            },
            $route: {
                handler(to,from) {
                    let routeName = this.$route.name;
                    console.log('apple-index,当前页面路由：' , routeName,from);
                    console.log('apple-index,to页面路由：' , to);
                },
                immediate: true,
                deep: true
            },
        },
        async mounted(){
            document.addEventListener('click', handleDocumentNoctiyClick);
            await this.getCommonConfig();
            let routeParams = this.$route.params||{};
            let routeName = this.$route.name;
            if(['apple_keyword','apple_search_term','apple_negative_keyword'].includes(routeName)){
                this.activeTabName = 'keywords';
            }else{
                this.activeTabName = this.$route.name;
            }
            this.$store.commit('apple/SET_CUR_TAB_PAGE',this.$route.name);
            if(!routeParams.range){
                let today = dayjs().format('YYYY-MM-DD');
                let dateConfig = this.apple_common_config.dynamic_day_type;

                // 0-今天，1-昨天，3-近三天，7-近七天，默认0
                if(dateConfig=='0'){
                    this.range_time = [today,today];
                }else if(dateConfig=='1'){
                    let yesTd = dayjs().subtract(1,'day').format('YYYY-MM-DD');
                    this.range_time = [yesTd,yesTd];
                }else if(dateConfig=='3'){
                    let last3 = dayjs().subtract(2,'day').format('YYYY-MM-DD');
                    this.range_time = [last3,today];
                }else if(dateConfig=='7'){
                    let last7 = dayjs().subtract(6,'day').format('YYYY-MM-DD');
                    this.range_time = [last7,today];
                }else{
                    this.range_time = [today,today];
                }
            }else{
                this.range_time = [...routeParams.range];
            }
            if(routeParams.zone){
                this.timeZone = routeParams.zone;
            }
            this.getTimeZone();
            this.getPriceDecimalPlacesConfig();
        },
        methods:{
            async getCommonConfig(){
                console.log('getCommonConfig1')
                await API.getCommonConfig().then(res=>{
                    console.log('getCommonConfig2',res);
                    let resData = res.data||{};
                    this.$store.commit('apple/SET_COMMON_CONFIG',{
                        dynamic_day_type:resData.dynamic_day_type,
                        search_filter_toggle:resData.search_filter_toggle,
                    });
                },err=>{
                    console.log(err,'getCommonConfig err2');
                })
                console.log('getCommonConfig2.1')
            },
            getPriceDecimalConfig(){
                return this.priceDecimalConfig;
            },
            async getPriceDecimalPlacesConfig(){
                await API.getPriceDecimalPlacesConfig().then(res=>{
                    console.log(res,'getPriceDecimalPlacesConfig');
                    this.priceDecimalConfig = res.data||[];
                },err=>{
                    console.log(err,'getPriceDecimalPlacesConfig err');
                    this.priceDecimalConfig = [];
                })
            },
            changeTab(tab){
                window.scrollTo(0, 0);
                let tabName = tab.name||'';

                let isHasKeywordTab = this.pageActionNames.includes('apple_keyword');
                let isHasSearchTermTab = this.pageActionNames.includes('apple_search_term');
                let isHasNegativeKeywordTab = this.pageActionNames.includes('apple_negative_keyword');
                let defaultPage = 'home';
                if(isHasKeywordTab){
                    defaultPage = 'apple_keyword';
                }else if(isHasSearchTermTab){
                    defaultPage = 'apple_search_term';
                }else if(isHasNegativeKeywordTab){
                    defaultPage = 'apple_negative_keyword';
                }
                // apple_adgroup apple_campaign
                let router_name = this.$route.name;
                console.log('changeTab',tabName,router_name);
                if(router_name == tabName) {
                    this.$refs[this.activeTabName].getSearchList('clearTab');
                }else{
                    localStorage.removeItem('AppleQueryRestoreData');
                    /* tabName：是要跳到的页面，router_name是跳转前的页面 */
                    if(tabName=='apple_org'){
                        this.$store.commit('apple/RESET_LIST_PAGE_QUERY');
                    }else if(tabName=='apple_campaign'){
                        if(router_name=='apple_keyword'||router_name=='apple_search_term'||router_name=='apple_negative_keyword'){
                            this.$store.commit('apple/CLEAR_ADGROUP_LIST_PAGE_QUERY');
                        }
                        this.$store.commit('apple/CLEAR_CAMPAIGN_LIST_PAGE_QUERY');
                    }else if(tabName=='apple_adgroup'){
                        this.$store.commit('apple/CLEAR_ADGROUP_LIST_PAGE_QUERY');
                    }

                    this.$router.push({
                        name:tabName=='keywords'?defaultPage:tabName,
                        params:{
                            range:this.range_time,
                            zone:this.timeZone,
                        }
                    });
                }
            },
            clickTabItem(ev){
                // window.scrollTo(0, 0);
                let $target = ev.target;
                // console.log('clickTabItem',$target,$target.className,$target.id);
                let className = $target.className||'';
                let idName = $target.id||'';
                if(className.includes('is-active')&&className.includes('el-tabs__item')){
                    let tabNames = ['apple_org','apple_campaign','apple_adgroup','keywords'].map(item=>'tab-'+item);
                    if(tabNames.includes(idName)){
                        this.$nextTick(()=>{
                            if(this.activeTabName == 'keywords'){
                                this.$refs.keywords.getSearchList('clearTab');
                            }else{
                                this.$refs[this.activeTabName].getSearchList('clearTab');
                            }

                            console.log('刷新当前tab');
                        })
                    }
                }
            },
            initPageStates(){
                console.log('initPageStates');
                console.log('pageFunc',this.pageFunc);
                console.log('pageFields',this.pageFields);
            },
            getTimeZone(){
                API.getTimeZone().then(res=>{
                    let resData = res.data||{};
                    this.timeZone = resData.time_zone||'Asia/Shanghai';
                })
            },
            updateZone(zone,range){
                console.log('updateZone',zone,range);
                this.range_time = range;
                this.timeZone = zone;
                this.$nextTick(()=>{
                    if(this.activeTabName == 'keywords'){
                        this.$refs.keywords.updateZone();
                    }else{
                        this.$refs[this.activeTabName].getSearchList();
                    }
                });

                API.setTimeZone({
                    time_zone:zone,
                }).then(res=>{

                    console.log('setTimeZone',res);
                },err=>{
                    this.$message.error(err.info||'修改失败');
                });
            },
            // 创建广告
            AddAd(){
                let routeName = this.$route.name;
                console.log(routeName);
                let typeMap = {
                    apple_org:'org_add_ad',
                    apple_campaign:'campaign_add_ad',
                    apple_adgroup:'adgroup_add_ad',
                    apple_keyword:'keyword_add_ad',
                    apple_search_term:'search_term_add_ad',
                    apple_negative_keyword:'negative_keyword_add_ad',
                };
                let urlName = typeMap[routeName];
                if(urlName){
                    this.addLoading = true;
                    API['check_'+urlName]().then(async ()=>{
                        this.addLoading = false;
                        this.$store.commit('apple/SUBMIT_URL_NAME',urlName);
                        if(urlName == 'apple_adgroup') {
                            this.$store.commit('apple/SET_CREATE_TYPE','createGroup');
                        }else{
                            this.$store.commit('apple/SET_CREATE_TYPE','createOrg');
                        }
                        let storeQueryData = this.apple_list_page_query;
                        console.log('storeQueryData',storeQueryData);
                        await this.getRelatesInfo(storeQueryData);
                        this.ads_show = true;
                    },err=>{
                        this.$message.error(err.info||'请求失败');
                        this.addLoading = false;
                    })

                }else{
                    this.addLoading = false;
                    this.$message.error('操作有误');
                }

            },
            async getRelatesInfo(data){
                let keyArr = Object.keys(data||{});
                if(keyArr.length<=0) return;
                // let isMultiData = keyArr.some(item=>Array.isArray(data[item])&&data[item].length>1);
                // if(isMultiData) return console.log('筛选项有多个，无法带入相关信息哦');

                // let reqData = {};
                // keyArr.forEach(item=>{
                //     let dataItem = data[item];
                //     if(Array.isArray(dataItem)){
                //         reqData[item] = dataItem[0];
                //     }else{
                //         reqData[item] = dataItem;
                //     }
                // });
                let res = await API.getRelatesInfo({...data});
                let resData = res.data||{};
                this.preData = {...resData};
                console.log('getRelatesInfo',resData);
            },
            handleadsClose(params) {
                window.scrollTo(0, 0);
                this.ads_show = false
                if(params.name == 'createGroup') {
                    // this.activeTabName = 'apple_adgroup'
                    this.$nextTick(()=>{
                        this.$store.commit('apple/RESET_LIST_PAGE_QUERY');
                        this.changeTab({
                            name:'apple_adgroup',
                        });
                    });
                }else if(params.name == 'createOrg') {
                    // this.activeTabName = 'apple_campaign'
                    this.$nextTick(()=>{
                        this.$store.commit('apple/RESET_LIST_PAGE_QUERY');
                        this.changeTab({
                            name:'apple_campaign',
                        });
                    });
                }

            },
            async handleClickAddGroup() {
                let storeQueryData = this.apple_list_page_query;
                await this.getRelatesInfo({...storeQueryData});
                this.ads_show = true;
            },
            async handleClickAddCampaign(type,data){
                console.log('handleClickAddCampaign',type,data);
                let storeQueryData = this.apple_list_page_query;
                await this.getRelatesInfo({...storeQueryData});
                this.ads_show = true;
            },
        }

    }
</script>

<style lang="scss" scoped>
    .tab-bar::after{
        content: '';
        position: absolute;
        left: -20px;
        right: -20px;
        background-color: #fff;
    }
    .tab-bar ::v-deep .el-tabs__header{
        background-color: #fff;
        margin-bottom: 10px;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    .tab-bar ::v-deep .el-tab-pane{
        margin: 0 15px;
    }

    .bg-wrap-color{
        padding: 0;
        background-color:#F1F4F9;
    }

    .time-zone{
        position: absolute;
        right: 20px;
        top: 5px;
    }

    ::v-deep .el-tabs__item.is-active.is-disabled{
        color: #409EFF;
    }
</style>
